import i18n from "i18next"
import { initReactI18next } from "react-i18next"

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  // Disable backend loading since we're manually loading resources
  initImmediate: false,
  // Add empty resources to prevent backend warnings
  resources: {},
})

export default i18n
